import { render, staticRenderFns } from "./BadgeComponent.vue?vue&type=template&id=0706fab8&scoped=true&"
import script from "./BadgeComponent.vue?vue&type=script&lang=js&"
export * from "./BadgeComponent.vue?vue&type=script&lang=js&"
import style0 from "./BadgeComponent.vue?vue&type=style&index=0&id=0706fab8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0706fab8",
  null
  
)

export default component.exports